const DAY_MS = 24 * 60 * 60 * 1000;

/** Below this many days left, a pending invite is flagged "Expires soon". */
export const EXPIRES_SOON_DAYS = 3;

/** Whole days until an invite expires (`expiresAt` is unix seconds), rounded up; 0 once expired. */
export const getDaysRemaining = (expiresAt, now = Date.now()) =>
  Math.max(0, Math.ceil((Number(expiresAt) * 1000 - now) / DAY_MS));

export const formatExpiry = (days) => {
  if (days <= 0) return 'Expired';
  if (days === 1) return 'in 1 day';
  return `in ${days} days`;
};
